/**
 * Legacy `showSearch` threshold: Search appears when entity option count is greater than 5
 * (`filters-compliance-reviews.component.html`). Count entity options only — do not include
 * the "All sites / departments / units" sentinel.
 */
export const FILTER_SEARCH_MIN_OPTIONS = 5

export const orgFilterNeedsSearch = (entityOptionCount: number): boolean =>
  Number.isFinite(entityOptionCount) && entityOptionCount > FILTER_SEARCH_MIN_OPTIONS
